import type { ISelectionTypeProps, SelectionTypes } from "pro-features/components/AutocompleteWithTabs/types";
import { EDisableState, ESelectionType } from "pro-features/components/AutocompleteWithTabs/types";
import { translate } from "app/filters/i18nFilter";
import { EAssetType } from "app/UtilitiesAndConstants/types/assetType";

const { Website, Segment, Company } = EAssetType;
const { SINGLE } = ESelectionType;
const DEFAULT_SELECTION_TYPES: SelectionTypes = {
    [Website]: SINGLE,
    [Segment]: SINGLE,
    [Company]: SINGLE,
};
export const DEFAULT_SELECTION_TYPE_PROPS: ISelectionTypeProps = {
    selectionTypes: DEFAULT_SELECTION_TYPES,
    numberOfSelectableEntities: Infinity,
    numberOfSelectableSegments: Infinity,
};
const {
    DISABLED_DUE_TO_DOMAIN_AND_SEGMENTS_OVERLAPPING,
    DISABLED_DUE_TO_MAX_SEGMENTS_AMOUNT,
    DISABLED_DUE_TO_MAX_ENTITIES_AMOUNT,
} = EDisableState;

export const DISABLED_TOOLTIPS: Pick<
    Record<EDisableState, string>,
    | EDisableState.DISABLED_DUE_TO_MAX_SEGMENTS_AMOUNT
    | EDisableState.DISABLED_DUE_TO_MAX_ENTITIES_AMOUNT
    | EDisableState.DISABLED_DUE_TO_DOMAIN_AND_SEGMENTS_OVERLAPPING
> = {
    get [DISABLED_DUE_TO_MAX_SEGMENTS_AMOUNT]() {
        return translate("market.builder.domains.autocomplete.segments.limit");
    },
    get [DISABLED_DUE_TO_MAX_ENTITIES_AMOUNT]() {
        return translate("marketbuilder.import.disable.tooltip");
    },
    get [DISABLED_DUE_TO_DOMAIN_AND_SEGMENTS_OVERLAPPING]() {
        return translate("marketbuilder.autocomplete.disable.overlap.tooltip");
    },
};
